var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4003_473)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6123 21.371L12.1333 23.4001C12.3381 23.6731 12.6588 23.8334 13 23.8334C13.3413 23.8334 13.6619 23.6731 13.8667 23.4001L15.3877 21.371C19.6159 20.305 22.75 16.4743 22.75 11.9167C22.75 6.53583 18.3809 2.16675 13 2.16675C7.61908 2.16675 3.25 6.53583 3.25 11.9167C3.25 16.4743 6.38408 20.305 10.6134 21.3721L10.6123 21.371Z",
    fill: "url(#paint0_linear_4003_473)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0832 14.0845V8.66781C14.0832 8.07017 13.5978 7.58447 12.9998 7.58447C12.4018 7.58447 11.9165 8.07017 11.9165 8.66781V14.0845C11.9165 14.6821 12.4018 15.1678 12.9998 15.1678C13.5978 15.1678 14.0832 14.6821 14.0832 14.0845Z",
    fill: "#1A3169"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0832 13.0012V7.58456C14.0832 6.98692 13.5978 6.50122 12.9998 6.50122C12.4018 6.50122 11.9165 6.98692 11.9165 7.58456V13.0012C11.9165 13.5989 12.4018 14.0846 12.9998 14.0846C13.5978 14.0846 14.0832 13.5989 14.0832 13.0012Z",
    fill: "url(#paint1_linear_4003_473)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0533 17.8588C12.3437 18.3821 13.0034 18.5706 13.5267 18.2803C14.0488 17.9899 14.2384 17.3302 13.9481 16.808C13.6578 16.2848 12.9969 16.0963 12.4748 16.3866C11.9515 16.6769 11.763 17.3367 12.0533 17.8588Z",
    fill: "#1A3169"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0533 16.7753C12.3437 17.2986 13.0034 17.4871 13.5267 17.1968C14.0488 16.9064 14.2384 16.2467 13.9481 15.7245C13.6578 15.2013 12.9969 15.0128 12.4748 15.3031C11.9515 15.5934 11.763 16.2532 12.0533 16.7753Z",
    fill: "url(#paint2_linear_4003_473)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4003_473",
    x1: 10.621,
    y1: 19.5347,
    x2: 16.8881,
    y2: 2.2285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4003_473",
    x1: 12.3964,
    y1: 13.0227,
    x2: 13.3021,
    y2: 7.13805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4003_473",
    x1: 12.8843,
    y1: 17.0971,
    x2: 13.4411,
    y2: 14.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4003_473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d665c04249617171f1d15f0f573681c6.svg";
export { ForwardRef as ReactComponent };